// angular
import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
// managers
import { GrowlManager } from '../../manager/growl.manager';
import { DownloadManager } from '../../manager/download.manager';
import { ModelsManager } from '../../manager/models.manager';
// services
import { ServerMapping } from '../../service/serverMapping.service';
// models
import { MaterialDocRequest } from '../../model/materials/material_doc_request.model';
import { MaterialDocResponse } from '../../model/materials/material_doc_response.model';

@Injectable()
export class MaterialDocService {

  private searching = false;
  private contained_bean = undefined;

  constructor(private growlManager:     GrowlManager,
              private downloadManager:  DownloadManager,
              private serverMapping:    ServerMapping,
              private modelManager:     ModelsManager,
              private http:             Http) {}

  isSearching() { return this.searching; }

  searchDocs() {
    if (this.searching === false ) {
      this.searching = true;
      this.http.get(this.serverMapping.materialDocURL +
        '?material=' + this.modelManager.material_doc_request.material +
        '&company_code=' + this.modelManager.material_doc_request.company_code +
        '&language=' + this.modelManager.material_doc_request.language).subscribe
        (
          (response) => {
            // store the response
            const data = response.json();
            if (this.growlManager.checkForErrorInResponse(data)) {
              this.growlManager.showMessagesByResponse(data);
            } else {
              this.modelManager.material_doc_response = data;
            }

            this.searching = false;

            // response verify in console
            // console.log('IL SERVER RITORNA');
            // console.log(this.modelManager.material_doc_response);
            // console.log('BEAN');
            // console.log(this.modelManager.material_doc_response.contained_bean);
          },
          (error) => {
            console.log('--------------------------------');
            console.log('!!!An error has been occurred!!!');
            console.log(error);
            console.log('--------------------------------');
          }
        );
      }
  }

  // method wich downloads the document
  downloadDocument(docType, docNumber, docVersion, docPart, filePath, fileName) {
    this.http.get(this.serverMapping.docDownloadURL +
      '?doc_type=' + docType +
      '&doc_number=' + docNumber +
      '&doc_version=' + docVersion +
      '&doc_part=' + docPart +
	    '&file_path=' + 'filePath' +
      '&file_name=' + fileName).subscribe(
      (response) => {
        const data = response.json();
        if (!data.download) {
        this.growlManager.checkForErrors(data);
        } else {
        this.downloadManager.prepareDownload(data.download.data, data.download.file_name, data.download.mime_type);
        }
        console.log(data);
      },
      (error) => {
        console.log('--------------------------------');
        console.log('!!!An error has been occurred!!!');
        console.log(error);
        console.log('--------------------------------');
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/components/modal-material-doc/material-doc.service.ts